export const openChat: any = () => {
    const chatButtonNotInteracted = document.getElementById('embeddedChatFab');
    const chatButtonInteracted = document.getElementById('startChatFab');
    if (chatButtonNotInteracted) {
        chatButtonNotInteracted.click();
    } else if (chatButtonInteracted) {
        chatButtonInteracted.click();
    }
};
